import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import ClampLines from 'react-clamp-lines'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import Link from '../Link'
import WpTags from '../WpTags'
import {
  primaryCard,
  hero,
  titleContainer,
  date,
  title,
  description,
  ousterBlogPrimaryCard,
  author,
  authorDateContainer,
  outer,
  inner,
  readMore,
  readMoreArrow,
  left,
  center,
  right,
} from './index.module.css'
import ArrowRight from '../../../assets/images/ArrowRightNoFill.svg'
import {
  mapLocaleData,
  getLocaleData,
  decodeHtml,
  isSvgOrGif,
} from '../../utils'

const WpPrimaryBlogPostPreview = ({ data, defaultdata, location }) => {
  const node = data.node
  const [featuredAlignmentClass, setFeaturedAlignmentClass] = useState(left)
  const [content, setContent] = useState(left)
  const postDate = node.date ? node.date : ''
  const intl = useIntl()
  const readMoreText = intl.formatMessage({ id: 'blog.readMore' })
  const defaultAuthor = intl.formatMessage({ id: 'blog.defaultAuthor' })
  const tags = node.tags.nodes.map((tag) => tag)
  const homeUrl = intl.formatMessage({ id: 'blog.homeUrl' })
  const authorName = node.author.node.userProfile.authorProfile
    ? node.author.node.userProfile.authorProfile.title
    : defaultAuthor

  useEffect(() => {
    switch (node.postOptions.featuredOverlayAlignment) {
      case 'center':
        return setFeaturedAlignmentClass(center)

      case 'right':
        return setFeaturedAlignmentClass(right)

      default:
        return setFeaturedAlignmentClass(left)
    }
  }, [node])

  useEffect(() => {
    setContent(
      decodeHtml(
        node.postOptions.metaDescription
          ? node.postOptions.metaDescription
          : node.excerpt
      )
    )
  }, [])

  return (
    <div className={ousterBlogPrimaryCard}>
      {node && (
        <Link to={`${homeUrl}${node.slug + '/'}`}>
          <div className={hero}>
            <div className={outer}>
              <div className={inner}>
                {node.featuredImage &&
                node.featuredImage.node.localFile.childImageSharp ? (
                  <GatsbyImage
                    image={getImage(node.featuredImage.node.localFile)}
                    alt={node?.featuredImage?.node?.altText}
                    loading={'eager'}
                  />
                ) : isSvgOrGif(
                    node?.featuredImage?.node?.localFile?.publicUrl
                  ) ? (
                  <img
                    src={node?.featuredImage?.node?.localFile?.publicUrl}
                    alt={node?.featuredImage?.node?.altText}
                  />
                ) : (
                  <GatsbyImage
                    image={getImage(defaultdata.authorBannerDefault.localFile)}
                    alt={node?.featuredImage?.node?.altText}
                    loading={'eager'}
                  />
                )}
              </div>
            </div>
          </div>
        </Link>
      )}

      {node && (
        <div className={[primaryCard, featuredAlignmentClass].join(' ')}>
          {tags.length > 0 && <WpTags tags={tags} location={location} />}

          <div className={titleContainer}>
            <h3 className={title}>
              <Link to={`${homeUrl}${node.slug + '/'}`}>{node.title}</Link>
            </h3>
            <div className={authorDateContainer}>
              <Link to={`${homeUrl}${node.slug + '/'}`} className={date}>
                {postDate}&nbsp;—&nbsp;
              </Link>
              {node.author.node.userProfile.authorProfile ? (
                <Link
                  to={`${homeUrl}author/${
                    node.author.node.userProfile.authorProfile.slug + '/'
                  }`}
                  className={author}
                >
                  {authorName}
                </Link>
              ) : (
                <p className={author}>{authorName}</p>
              )}
            </div>
          </div>
          <Link to={`${homeUrl}${node.slug + '/'}`}>
            <ClampLines
              className={description}
              lines={4}
              text={content}
              innerElement="div"
              buttons={false}
              delay={0}
            />

            <div className={readMore}>
              {readMoreText}
              <ArrowRight className={readMoreArrow} />
            </div>
          </Link>
        </div>
      )}
    </div>
  )
}

export default WpPrimaryBlogPostPreview
